export const messagesFromReasonCode = {
  'GOODWILL GESTURE': 'journeySegment.aftersaleOverrideReasonGoodwill',
  'GOODWILL GESTURE VOUCHER B4DD': 'journeySegment.aftersaleOverrideReasonGoodwill',
  'FREE EXCHANGE': 'journeySegment.aftersaleOverrideReasonFree',
  PRR: 'journeySegment.aftersaleOverrideReasonPrr',
  'LOYALTY EXCHANGED': 'journeySegment.loyaltyExchanged',
  'CANCELLATION PRR': 'journeySegment.aftersaleOverrideReasonPrr',
  'DISRUPTION PRR': 'journeySegment.aftersaleOverrideReasonPrr'
};

export const messagesFromReasonCodeOnHold = {
  'GOODWILL GESTURE': 'journeySegment.aftersaleOverrideReasonGoodwill',
  'GOODWILL GESTURE VOUCHER B4DD': 'journeySegment.aftersaleOverrideReasonGoodwill',
  'FREE EXCHANGE': 'journeySegment.aftersaleOverrideReasonFree',
  PRR: 'journeySegment.aftersaleOverrideReasonPrr',
  'LOYALTY EXCHANGED': 'journeySegment.loyaltyExchanged',
  'CANCELLATION PRR': 'journeySegment.aftersaleOverrideReasonOnHoldCancellationPrr',
  'DISRUPTION PRR': 'journeySegment.aftersaleOverrideReasonOnHoldDisruptionPrr'
};

export const aftersalesOverrideProfile = {
  'GOODWILL GESTURE': 'aftersalesWarning.AOPMismatch'
};

export const defaultMessage = 'journeySegment.aftersaleOverrideReasonDefault';
